export const whToKwh = (wh: number, digits = 0): number => {
  if (!digits) {
    return Math.round(wh / 1000);
  }

  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  const factor = 10 ** digits;
  return Math.round((wh / 1000) * factor) / factor;
};
